import { Typography } from "@material-ui/core"

const Provide = (props) => {

  return ( <>
    <Typography>
      You can absolutely provide your own lyrics! If you’ve already poured your heart (or your sense of humor) into a set of words, we’re happy to turn them into a full song. However, when it comes to the melody, we leave that to our talented song creators—they’ll craft the perfect tune to match your lyrics and bring your vision to life. Think of it like a surprise gift, but for your ears!
    </Typography>
  </> )
}

export default Provide
